export default {
  en: {
    name: 'Name',
    type: 'Type',
    market: 'Market',
    contactPerson: 'Contact Person',
    addAgent: '+ Add Agent',
    edit: 'Edit',
    remove: 'Remove',
    confirmRemoveAgentMessage: 'Confirm to delete Agent <strong>{agentName}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    keyword: 'Keyword',
    updatedAgentMessage: 'This agent has been updated',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions'
  },
  th: {
    name: 'ชื่อ',
    type: 'ประเภท',
    market: 'ตลาด',
    contactPerson: 'ชื่อผู้ติดต่อ',
    addAgent: '+ เพิ่มตัวแทน',
    edit: 'แก้ไข',
    remove: 'ลบ',
    confirmRemoveAgentMessage: 'กรุณายืนยันการลบ <strong>{agentName}</strong>?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    keyword: 'ค้นหา',
    updatedAgentMessage: 'ตัวแทนนี้มีการแก้ไข',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions'
  }
}
